import type { Image } from "../../../aysa_api/shared/v1/image.types";
import { Reader, Writer } from "protobufjs/minimal";

export const createBaseImage = (): Image => {
  return {
    url: "",
    description: "",
  };
};

export const decodeImage = (reader: Reader, length: number): Image => {
  const end = reader.pos + length;
  const message = createBaseImage();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.url = reader.string();

        break;
      case 2:
        message.description = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeImage = (writer: Writer, message: Image): Writer => {
  writer.uint32(10).string(message.url);
  writer.uint32(18).string(message.description);

  return writer;
};
